import { useQuery, useMutation } from '@apollo/client'
import { PROMPT_PROGRESS_UPDATE } from 'Apollo/Mutations/PromptProgessUpdate'
import { NEEDS_PROGRESS_UPDATE } from 'Apollo/Queries/NeedsProgressUpdate'

export const useProgressUpdatePrompt = () => {
  const { data, loading, error } = useQuery(NEEDS_PROGRESS_UPDATE)
  const [markPrompted] = useMutation(PROMPT_PROGRESS_UPDATE)

  return {
    needsProgressUpdate:
      data?.needsProgressUpdate?.needsProgressUpdate ?? false,
    loading,
    error,
    markPrompted,
  }
}
